module.exports = __webpack_public_path__ + "img/UX Designer.43b846ed.png";